module.exports = require("@git-stack/client-redux");